import { IDmQuocTich } from "../../../model/respone/category/IDmQuocTich";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eDmQuocTichActionsObj = {
  LOAD_START: undefined,
  LOAD_SUCCESS: {} as IDmQuocTich[],
  LOAD_ERRR: "",
};
export const eDmQuocTichActionIds = generateActionTypeIds(
  eDmQuocTichActionsObj,
  "QUOC_TICH"
);
export type IDmQuocTichActionTypes = IGenericActionType<
  typeof eDmQuocTichActionsObj,
  "QUOC_TICH"
>;
